
import { defineComponent } from 'vue'
import VButton from '@/components/shared/button/VButton.vue'
import ADD_COMMA from '@/assets/utils/add-comma.util'
import IPagination from '@/types/api/pagination.type'
import Pagination from '@/components/shared/pagination/Pagination.vue'
import { RewardDetail } from '@/types/core/reward.type'

export default defineComponent({
  name: 'RewardDetail',
  components: {
    Pagination,
    VButton,
  },
  props: {
    rewardTransactionMonthlyId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      ACTION_MENU: [
        {
          label: 'View Detail',
          actionKey: 'viewDetail',
        },
      ],
      isShowDialog: false as boolean,
      pagination: {
        page: 1,
        length: 10,
      } as Pick<IPagination, 'page' | 'length'>,
    }
  },
  computed: {
    firstIndexInPage(): number {
      return (this.pagination.page - 1) * this.pagination.length
    },
    isLoadingRewardDetail(): boolean {
      return this.$store.getters['isLoadingRewardDetail']
    },
    isErrorLoadingRewardDetail(): boolean {
      return this.$store.getters['isErrorRewardDetail']
    },
    rewardDetail(): RewardDetail  {
      return this.$store.getters['rewardDetail']
    },
    paginationRewardDetailList(): IPagination {
      return this.$store.getters['paginationRewardDetailList']
    },
  },
  watch: {
    isShowDialog: {
      handler: async function (newVal: boolean) {
        if (newVal) {
          await this.getRewardDetail()
        } else {
          this.$store.dispatch("resetRewardDetail");
          this.pagination = { page: 1, length: 10 };
        }
      },
    },
    isLoadingRewardDetail: {
      deep: true,
      handler: function (newVal: string) {
        if (!newVal && !this.isErrorLoadingRewardDetail) {
          this.pagination = {
            page: this.paginationRewardDetailList.page,
            length: this.paginationRewardDetailList.length,
          }
        }
      },
    },
  },
  methods: {
    addComma: ADD_COMMA,
    handleActionClick(actionKey: string) {
      if (actionKey === 'viewDetail') this.isShowDialog = true
    },
    async getRewardDetail() {
      if (!this.rewardTransactionMonthlyId) return
      try {
        await this.$store.dispatch('getRewardDetail', {
          rewardTransactionMonthlyId: this.rewardTransactionMonthlyId,
          pagination: this.pagination,
        })
      } catch (error) {
        console.error('Error fetching reward detail:', error)
      }
    },
    formatDate(dateString: string): string {
      if (dateString === '') return ''
      return this.$dayjs(dateString).format('DD/MM/YYYY')
    },
    handlePageChange(nextPage: number) {
      if (nextPage < 1) {
        this.pagination.page = 1
      } else if (nextPage > this.paginationRewardDetailList.totalPages) {
        this.pagination.page = this.paginationRewardDetailList.totalPages
      } else {
        this.pagination.page = nextPage
      }
      this.getRewardDetail()
    },
    handleSelectPageNumber(pageNumber: number) {
      this.pagination.page = pageNumber
      this.getRewardDetail()
    },
    handlePageLengthChange(pageLength: number) {
      this.pagination.length = pageLength
      this.pagination.page = 1
      this.getRewardDetail()
    },
    async DoExportExcel() {
      await this.$store.dispatch('getExcelRewardDetail', {
        rewardTransactionMonthlyId: this.rewardTransactionMonthlyId,
        pagination: this.pagination,
      });
    },
    getActionTypeWording(actionType: string): string {
      switch (actionType) {
        case 'PAYMENT':
          return 'Payment';
        case 'CREATE_MERCHANT':
          return 'Create Merchant';
        case 'REGISTER':
          return 'Register';
        default:
          return actionType;
      }
    }
  },
})
